// @flow

import styled, { css } from 'styled-components';

export const TextField = styled.input.attrs({ type: 'text' })`
  height: 48px;
  padding: 14px;
  border: 1px solid rgb(203, 203, 203);
  border-radius: 3px;
  outline: 0;

  &::placeholder {
    color: #ddd;
  }

  &:focus {
    border-color: rgb(35, 151, 212);
  }
  
  ${props => props.fashion === 'error' && css`
    border-color: #ec7063;
  `}
`;
